import React, { Children } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/ui/Footer';
import { motion } from 'framer-motion';
import { Database, Cloud, CheckCircle } from 'lucide-react';
const fadeInUp = {
  initial: {
    opacity: 0,
    y: 30
  },
  animate: {
    opacity: 1,
    y: 0
  },
  transition: {
    duration: 0.8,
    ease: [0.22, 1, 0.36, 1]
  }
};
const staggerContainer = {
  animate: {
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.1
    }
  }
};
export function PartnersPage() {
  const mdmPlatforms = [{
    name: 'Profisee',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/g3ozH3aPbyxxRenLG5cR3k/pasted-image.png',
    url: 'https://profisee.com/?utm_source=ProviderMDM&utm_medium=partner+promotion&lsd=PL-ProviderMDM'
  }, {
    name: 'Gaine',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/sNHBiBuBjErXzsLzJqMBUV/gaine.png',
    url: 'https://www.gaine.com'
  }];
  const dataServices = [{
    name: 'Veritas',
    category: 'Death Master File',
    badge: 'Mortality',
    badgeColor: 'bg-purple-500/10 text-purple-300',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/p1ArbvZUJzE49CvgSV9Vkt/pasted-image.svg',
    url: 'https://veritasdataresearch.com'
  }, {
    name: 'Veritas',
    category: 'Provider Network Data',
    badge: 'Provider Network',
    badgeColor: 'bg-green-500/10 text-green-300',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/p1ArbvZUJzE49CvgSV9Vkt/pasted-image.svg',
    url: 'https://veritasprovidernetwork.com'
  }];
  return <div className="bg-black min-h-screen" data-id="element-274">
      <Header data-id="element-275" />
      <main className="pt-32 pb-24 px-6" data-id="element-276">
        <div className="max-w-7xl mx-auto" data-id="element-277">
          <motion.div className="mb-16 text-center" initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: [0.22, 1, 0.36, 1]
        }} data-id="element-278">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-medium text-white mb-6 font-roboto-condensed" data-id="element-279">
              Our Technology Portfolio
            </h1>
            <p className="text-xl text-white/80 max-w-3xl mx-auto leading-relaxed" data-id="element-280">
              We partner with industry-leading platforms and services to deliver
              comprehensive MDM solutions.
            </p>
          </motion.div>
          <motion.div variants={staggerContainer} initial="initial" whileInView="animate" viewport={{
          once: true,
          margin: '-100px'
        }} className="space-y-16" data-id="element-281">
            <motion.section variants={fadeInUp} data-id="element-282">
              <div className="flex items-center gap-3 mb-8" data-id="element-283">
                <Database className="w-8 h-8 text-purple-400" data-id="element-284" />
                <h2 className="text-3xl font-semibold text-white font-roboto-condensed" data-id="element-285">
                  MDM Platforms
                </h2>
              </div>
              <motion.div className="grid md:grid-cols-3 gap-6" variants={staggerContainer} initial="initial" whileInView="animate" viewport={{
              once: true
            }} data-id="element-286">
                {mdmPlatforms.map((platform, index) => <motion.a key={index} href={platform.url} target="_blank" rel="noopener noreferrer" variants={fadeInUp} className="bg-white/40 border border-white/10 rounded-xl p-8 hover:bg-white/50 transition-all duration-300 flex items-center justify-center cursor-pointer" whileHover={{
                y: -8,
                scale: 1.05
              }} data-id="element-287">
                    {platform.logo ? <img src={platform.logo} alt={platform.name} className="w-full h-auto object-contain max-h-16" data-id="element-288" /> : <p className="text-xl font-semibold text-white" data-id="element-289">
                        {platform.name}
                      </p>}
                  </motion.a>)}
              </motion.div>
            </motion.section>

            <motion.section variants={fadeInUp} data-id="element-290">
              <div className="flex items-center gap-3 mb-8" data-id="element-291">
                <CheckCircle className="w-8 h-8 text-green-400" data-id="element-292" />
                <h2 className="text-3xl font-semibold text-white font-roboto-condensed" data-id="element-293">
                  Data Services
                </h2>
              </div>
              <p className="text-white/70 mb-8 leading-relaxed" data-id="element-294">
                We maintain a focused partnership with Veritas Data Research,
                providing comprehensive data services including mortality data
                and provider network information for critical data quality and
                compliance needs.
              </p>
              <motion.div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" variants={staggerContainer} initial="initial" whileInView="animate" viewport={{
              once: true
            }} data-id="element-295">
                {dataServices.map((service, index) => <motion.a key={index} href={service.url} target="_blank" rel="noopener noreferrer" variants={fadeInUp} className="bg-white/15 border border-white/10 rounded-xl p-8 hover:bg-white/20 transition-all duration-300 cursor-pointer" whileHover={{
                scale: 1.05,
                y: -5
              }} data-id="element-296">
                    {service.logo && <div className="mb-4 flex items-center justify-center h-16" data-id="element-297">
                        <img src={service.logo} alt={service.name} className="h-full w-auto object-contain max-w-full" data-id="element-298" />
                      </div>}
                    <div className="flex justify-center mb-3" data-id="element-299"></div>
                    <p className="text-sm text-white/60 text-center" data-id="element-300">
                      {service.category}
                    </p>
                  </motion.a>)}
              </motion.div>
            </motion.section>
            <motion.section variants={fadeInUp} className="bg-gradient-to-br from-purple-500/10 to-cyan-500/10 border border-white/10 rounded-2xl p-8 lg:p-12 text-center" data-id="element-301">
              <h2 className="text-3xl font-semibold text-white mb-6 font-roboto-condensed" data-id="element-302">
                Ready to Leverage Our Partnership Network?
              </h2>
              <p className="text-lg text-white/80 leading-relaxed mb-8 max-w-2xl mx-auto" data-id="element-303">
                Our extensive partner ecosystem means you get best-in-class
                solutions without the vendor evaluation headache.
              </p>
              <motion.a href="https://vantagedatagroup.com/contact" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center h-12 rounded-xl px-8 text-sm bg-white text-black font-semibold hover:bg-white/90 transition-colors" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} data-id="element-304">
                Schedule a Consultation
              </motion.a>
            </motion.section>
          </motion.div>
        </div>
      </main>
      <Footer data-id="element-305" />
    </div>;
}